import { render, staticRenderFns } from "./ComposicaoCustoTotalPercentual.vue?vue&type=template&id=39b0170a&scoped=true&"
import script from "./ComposicaoCustoTotalPercentual.vue?vue&type=script&lang=js&"
export * from "./ComposicaoCustoTotalPercentual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b0170a",
  null
  
)

export default component.exports